export default __webpack_public_path__ + "static/media/coin_brl.f3f5108e.svg";